import Vms from './Vms';

export default Vms;
